(function () {
  function initToc() {
    var root = document.getElementById('article-editorial-content');
    var toc = document.getElementById('article-editorial-toc-list');
    var tocNav = document.getElementById('article-editorial-toc');
    if (!root || !toc || !tocNav) {
      return false;
    }

    var headings = root.querySelectorAll('h2, h3');
    if (headings.length === 0) {
      tocNav.setAttribute('hidden', '');
      return false;
    }

    var slugCounts = {};
    headings.forEach(function (el) {
      if (!el.id) {
        var text = (el.textContent || '').trim();
        var base = text
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
          .slice(0, 64);
        if (!base) base = 'section';
        var count = slugCounts[base] || 0;
        slugCounts[base] = count + 1;
        el.id = count ? base + '-' + count : base;
      }

      var li = document.createElement('li');
      li.className =
        el.tagName === 'H3' ? 'article-editorial__toc-item article-editorial__toc-item--sub' : 'article-editorial__toc-item';
      var a = document.createElement('a');
      a.href = '#' + el.id;
      a.textContent = (el.textContent || '').trim();
      li.appendChild(a);
      toc.appendChild(li);
    });
    return true;
  }

  function initTocToggle() {
    var toggle = document.querySelector('[data-article-editorial-toc-toggle]');
    var panel = document.getElementById('article-editorial-toc-panel');
    if (!toggle || !panel) return;

    var desktop = window.matchMedia('(min-width: 990px)').matches;
    toggle.setAttribute('aria-expanded', desktop ? 'true' : 'false');
    panel.hidden = !desktop;

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      panel.hidden = expanded;
    });
  }

  function initCopyLink() {
    var btn = document.querySelector('[data-article-editorial-copy]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-url');
      if (!url || !navigator.clipboard) return;
      navigator.clipboard.writeText(url).then(function () {
        var prev = btn.getAttribute('aria-label');
        btn.setAttribute('aria-label', btn.getAttribute('data-copied-label') || 'Copied');
        window.setTimeout(function () {
          btn.setAttribute('aria-label', prev);
        }, 2000);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (initToc()) {
      initTocToggle();
    }
    initCopyLink();
  });
})();
